import { render, staticRenderFns } from "./lawsuitEquityForm.vue?vue&type=template&id=6b3c0e06&scoped=true"
import script from "./lawsuitEquityForm.vue?vue&type=script&lang=js"
export * from "./lawsuitEquityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3c0e06",
  null
  
)

export default component.exports